{
  "title": "Finance",
  "description": "Manage earnings, payouts, and bank details",
  "tabs": {
    "overview": "Overview",
    "transactions": "Transactions",
    "payouts": "Payouts",
    "bankDetails": "Bank Details"
  },
  "overview": {
    "availableBalance": "Available Balance",
    "availableBalanceHint": "Total balance from bookings, tips, and charges",
    "withdrawable": "Withdrawable",
    "withdrawableHint": "Amount available to withdraw (min. GH₵20)",
    "requestPayout": "Request Payout",
    "requestingPayout": "Requesting...",
    "payoutSuccess": "Payout requested successfully",
    "payoutError": "Failed to request payout",
    "recentActivity": "Recent Activity",
    "recentActivityHint": "Latest transactions for the selected business",
    "emptyTransactionsTitle": "No recent transactions",
    "emptyTransactionsDescription": "Transactions will appear here once you have activity",
    "metricsLoadFailed": "Failed to load finance metrics",
    "transactionsLoadFailed": "Failed to load recent transactions"
  },
  "income": {
    "documentTitle": "Income Management",
    "pageTitle": "Income Management",
    "pageDescription": "Manage payouts and bank details",
    "bankDetails": {
      "title": "Bank Details",
      "accountLabel": "Account"
    },
    "withdraw": "Withdraw",
    "requesting": "Requesting...",
    "metrics": {
      "available": "Available",
      "withdrawable": "Withdrawable"
    },
    "payoutsTitle": "Payouts",
    "payouts": {
      "searchPlaceholder": "Search payouts..."
    },
    "toast": {
      "payoutRequested": "Payout successfully requested",
      "payoutRequestFailed": "Failed to request payout"
    }
  },
  "bankDetails": {
    "dialogTitle": "Payout account information",
    "fullName": {
      "label": "Full name",
      "hint": "The name as it appears on your bank account",
      "placeholder": "John Doe"
    },
    "accountNumber": {
      "label": "Account number",
      "hint": "Your bank account number (digits only)"
    },
    "bank": {
      "label": "Bank",
      "hint": "Select your bank",
      "placeholder": "Select bank",
      "searchPlaceholder": "Search banks...",
      "emptyMessage": "No bank found"
    },
    "submit": "Add account",
    "adding": "Adding...",
    "errors": {
      "fullNameRequired": "Full name is required",
      "accountNumberRequired": "Account number is required",
      "bankRequired": "Please select a bank"
    },
    "toast": {
      "addInitiated": "Add business receiving account has been initiated"
    }
  },
  "transactions": {
    "pageTitle": "Transactions",
    "pageDescription": "Track and review recent transaction activity",
    "searchPlaceholder": "Search customer, transaction id...",
    "emptyTitle": "No Transactions",
    "emptyDescription": "Transactions will appear here once available."
  },
  "payouts": {
    "searchPlaceholder": "Search payouts...",
    "emptyTitle": "No Payouts",
    "emptyDescription": "Payout history will appear here once you withdraw."
  },
  "settings": {
    "payoutAccount": "Payout account",
    "payoutAccountHint": "Bank account where withdrawals will be sent",
    "editBankDetails": "Edit bank details",
    "accountNumber": "Account number",
    "noAccount": "No account configured",
    "addAccountHint": "Add your bank account to receive payouts from completed bookings."
  },
  "columns": {
    "customer": "Customer",
    "date": "Date",
    "type": "Type",
    "status": "Status",
    "reference": "Reference",
    "transactionId": "Transaction ID",
    "externalReference": "External Reference"
  },
  "transactionTypes": {
    "all": "All",
    "bookingFee": "Booking Fee",
    "additionalCharge": "Additional Charge",
    "tip": "Tip",
    "refund": "Refund",
    "subscriptionFee": "Subscription Fee",
    "payout": "Payout",
    "platformFee": "Platform Fee",
    "adPayout": "Ad Payout",
    "adRevenue": "Ad Revenue"
  },
  "transactionStatuses": {
    "pending": "Pending",
    "pendingAuthorization": "Pending Authorization",
    "pendingAny": "Pending",
    "completed": "Completed",
    "success": "Success",
    "failed": "Failed",
    "cancelled": "Cancelled",
    "initiated": "Initiated",
    "declined": "Declined"
  }
}
